module.exports = __webpack_public_path__ + "img/banner-betslip.b1c5830b.png";